import { Card } from 'antd';
import { FormInstance } from 'antd/lib/form';
import React from 'react';
import { useTranslation } from 'react-i18next';

import placeholderImage from '../../assets/placeholder-image.png';
import { GridListCardCover, GridListCardCoverProps } from '../GridList';
import { PreviewCampaignImageForm, PreviewCampaignImageFormProps } from '../PreviewCampaignImageForm';

interface Props extends Pick<PreviewCampaignImageFormProps, 'onFinish'>, GridListCardCoverProps {
  form: FormInstance;
}

export const PreviewCard = ({ form, loading, onFinish, alt, src, attribution }: Props) => {
  const { t } = useTranslation();

  return (
    <Card
      cover={
        <GridListCardCover
          src={src || placeholderImage}
          alt={alt || (t('PREVIEW_IMAGE_ALT') as string)}
          attribution={attribution}
          loading={loading}
        />
      }
    >
      <PreviewCampaignImageForm form={form} initialValues={{ sample: 'Meike' }} loading={loading} onFinish={onFinish} />
    </Card>
  );
};
